export default __webpack_public_path__ + "static/media/students2.2f70b3fa.jpg";